var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 14.5C9.91693 14.5 9.33359 14.275 8.89193 13.8334L3.45859 8.40003C3.21693 8.15837 3.21693 7.75837 3.45859 7.5167C3.70026 7.27503 4.10026 7.27503 4.34193 7.5167L9.77526 12.95C10.1753 13.35 10.8253 13.35 11.2253 12.95L16.6586 7.5167C16.9003 7.27503 17.3003 7.27503 17.5419 7.5167C17.7836 7.75837 17.7836 8.15837 17.5419 8.40003L12.1086 13.8334C11.6669 14.275 11.0836 14.5 10.5003 14.5Z",
    fill: "#19224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d697f46b9e683a156acfceb259ac4dfb.svg";
export { ForwardRef as ReactComponent };